import { SvgIcon } from 'components/Shared/SvgIcon';
import { IProductNew } from 'interfaces/product';
import { ITheme } from 'interfaces/theme';
import React, { Component } from 'react';
import { CDN_URL } from 'settings';
import { WithStyles } from 'decorators/withStyles';

interface IProps {
  classes: any;
  theme: ITheme;
  selectedTheme: ITheme;
  selectedProduct: IProductNew;
  onSelect: (theme: ITheme) => void;
}
@WithStyles(() => ({
  themeName: {
    color: '#37474F'
  },
  infosTheme: {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    height: 131,
    maxWidth: 270,
    minWidth: 270,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    border: 'solid 2px transparent',
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.1)'
    }
  },
  themeItem: {
    width: '33.3%',
    minHeight: 130,
    padding: '10px 15px 0 15px',
    minWidth: 300,
    '@media screen and (min-width: 1480px)': {
      width: '25%'
    }
  },
  themeItemContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  selectedTheme: {
    border: '3px solid #ffa500'
  },
  linkedTheme: {
    border: '3px solid #009358'
  }
}))
export default class ThemeItem extends Component<IProps> {
  onSelect = () => {
    this.props.onSelect(this.props.theme);
  };

  render() {
    const { classes, theme, selectedTheme, selectedProduct } = this.props;

    const className = [
      classes.infosTheme,
      selectedProduct && theme.linkedProducts.includes(selectedProduct.id) ? classes.linkedTheme : '',
      selectedTheme && theme ? (selectedTheme.id == theme.id ? classes.selectedTheme : '') : ''
    ].join(' ');

    return (
      <div className={`${classes.themeItem}`} onClick={this.onSelect} id={theme.id}>
        <div className={classes.themeItemContent}>
          <div className={className} style={{ backgroundImage: `url('${CDN_URL}${theme.imgDesktop}')` }}>
            {selectedProduct && theme.linkedProducts.includes(selectedProduct.id) && <SvgIcon name="checkTheme" />}
          </div>
          <p className={classes.themeName}>{theme.name}</p>
        </div>
      </div>
    );
  }
}
